'use strict';

import { Component } from '../../viewEngin/pview';
import eventEmitter, { CustomEvents } from '../../core/eventEmitter';
import { ILoaderView } from './loaderView.model';
import { IVnode } from '../../viewEngin/component.model';

/**
 * loaderView.component.tsx
 * @createdOn:31-Aug-19
 * @author:SmartChartsNXT
 * @description: This components will show loader screen.
 * @extends Component
 *
 * @event supported events -
 * 1. showLoader - To show loader screen.
 * 2. hideLoader - To hide loader screen.
 */

class LoaderView extends Component<ILoaderView> {
  private emitter: CustomEvents;
  constructor(props: ILoaderView) {
    super(props);
    this.emitter = eventEmitter.getInstance((this as any).context.runId);
    this.state = {
      showLoader: false
    };
    this.onShowLoader = this.onShowLoader.bind(this);
    this.onHideLoader = this.onHideLoader.bind(this);
  }

  afterMount(): void {
    this.emitter.on('showLoader', this.onShowLoader);
    this.emitter.on('hideLoader', this.onHideLoader);
  }

  beforeUnmount(): void {
    this.emitter.removeListener('showLoader', this.onShowLoader);
    this.emitter.removeListener('hideLoader', this.onHideLoader);
  }

  render(): IVnode {
    if (!this.state.showLoader) {
      return (<g class='no-loader'></g>);
    }
    return (
      <g id='smartsChartsNXT-loader-container'>
        <rect class='sc-overlay' x={0} y={0} width={(this as any).context.svgWidth} height={(this as any).context.svgHeight} opacity='0.2' fill='#000' ></rect>
        <g id='loader-icon' transform={`translate(${(this as any).context.svgWidth / 2},${((this as any).context.svgHeight / 2) - 40}) scale(0.6,0.6)`}>
          <rect x='-30' y='-30' width='160' height='160' stroke='#000' fill='#f1f1f1' class='bk' rx='10' opacity='0.8'></rect>
          <g transform='translate(-20,-20)'>
            <path d='M79.9,52.6C80,51.8,80,50.9,80,50s0-1.8-0.1-2.6l-5.1-0.4c-0.3-2.4-0.9-4.6-1.8-6.7l4.2-2.9c-0.7-1.6-1.6-3.1-2.6-4.5 L70,35c-1.4-1.9-3.1-3.5-4.9-4.9l2.2-4.6c-1.4-1-2.9-1.9-4.5-2.6L59.8,27c-2.1-0.9-4.4-1.5-6.7-1.8l-0.4-5.1C51.8,20,50.9,20,50,20 s-1.8,0-2.6,0.1l-0.4,5.1c-2.4,0.3-4.6,0.9-6.7,1.8l-2.9-4.1c-1.6,0.7-3.1,1.6-4.5,2.6l2.1,4.6c-1.9,1.4-3.5,3.1-5,4.9l-4.5-2.1 c-1,1.4-1.9,2.9-2.6,4.5l4.1,2.9c-0.9,2.1-1.5,4.4-1.8,6.8l-5,0.4C20,48.2,20,49.1,20,50s0,1.8,0.1,2.6l5,0.4 c0.3,2.4,0.9,4.7,1.8,6.8l-4.1,2.9c0.7,1.6,1.6,3.1,2.6,4.5l4.5-2.1c1.4,1.9,3.1,3.5,5,4.9l-2.1,4.6c1.4,1,2.9,1.9,4.5,2.6l2.9-4.1 c2.1,0.9,4.4,1.5,6.7,1.8l0.4,5.1C48.2,80,49.1,80,50,80s1.8,0,2.6-0.1l0.4-5.1c2.3-0.3,4.6-0.9,6.7-1.8l2.9,4.2 c1.6-0.7,3.1-1.6,4.5-2.6L65,69.9c1.9-1.4,3.5-3,4.9-4.9l4.6,2.2c1-1.4,1.9-2.9,2.6-4.5L73,59.8c0.9-2.1,1.5-4.4,1.8-6.7L79.9,52.6 z M50,65c-8.3,0-15-6.7-15-15c0-8.3,6.7-15,15-15s15,6.7,15,15C65,58.3,58.3,65,50,65z' fill='#000'>
              <animateTransform attributeName='transform' type='rotate' from='90 50 50' to='0 50 50' dur='1s' repeatCount='indefinite'></animateTransform></path>
          </g>
          <g transform='translate(20,20) rotate(15 50 50)'>
            <path d='M79.9,52.6C80,51.8,80,50.9,80,50s0-1.8-0.1-2.6l-5.1-0.4c-0.3-2.4-0.9-4.6-1.8-6.7l4.2-2.9c-0.7-1.6-1.6-3.1-2.6-4.5 L70,35c-1.4-1.9-3.1-3.5-4.9-4.9l2.2-4.6c-1.4-1-2.9-1.9-4.5-2.6L59.8,27c-2.1-0.9-4.4-1.5-6.7-1.8l-0.4-5.1C51.8,20,50.9,20,50,20 s-1.8,0-2.6,0.1l-0.4,5.1c-2.4,0.3-4.6,0.9-6.7,1.8l-2.9-4.1c-1.6,0.7-3.1,1.6-4.5,2.6l2.1,4.6c-1.9,1.4-3.5,3.1-5,4.9l-4.5-2.1 c-1,1.4-1.9,2.9-2.6,4.5l4.1,2.9c-0.9,2.1-1.5,4.4-1.8,6.8l-5,0.4C20,48.2,20,49.1,20,50s0,1.8,0.1,2.6l5,0.4 c0.3,2.4,0.9,4.7,1.8,6.8l-4.1,2.9c0.7,1.6,1.6,3.1,2.6,4.5l4.5-2.1c1.4,1.9,3.1,3.5,5,4.9l-2.1,4.6c1.4,1,2.9,1.9,4.5,2.6l2.9-4.1 c2.1,0.9,4.4,1.5,6.7,1.8l0.4,5.1C48.2,80,49.1,80,50,80s1.8,0,2.6-0.1l0.4-5.1c2.3-0.3,4.6-0.9,6.7-1.8l2.9,4.2 c1.6-0.7,3.1-1.6,4.5-2.6L65,69.9c1.9-1.4,3.5-3,4.9-4.9l4.6,2.2c1-1.4,1.9-2.9,2.6-4.5L73,59.8c0.9-2.1,1.5-4.4,1.8-6.7L79.9,52.6 z M50,65c-8.3,0-15-6.7-15-15c0-8.3,6.7-15,15-15s15,6.7,15,15C65,58.3,58.3,65,50,65z' fill='#000'>
              <animateTransform attributeName='transform' type='rotate' from='0 50 50' to='90 50 50' dur='1s' repeatCount='indefinite'></animateTransform>
            </path>
          </g>
        </g>
      </g>
    );
  }

  onShowLoader(): void {
    this.setState({ 'showLoader': true });
  }

  onHideLoader(): void {
    this.setState({ 'showLoader': false });
  }

}

export default LoaderView;